import React from "react";
import { useNavigate } from "react-router-dom";
import { HOME_THEME as T, PILLARS } from "../../lib/homeTheme";

const HOVER_RING: Record<(typeof PILLARS)[number]["hover"], string> = {
  lavender:
    "hover:border-[rgba(196,181,253,0.35)] hover:shadow-[inset_0_0_48px_rgba(196,181,253,0.08),0_8px_32px_rgba(196,181,253,0.06)]",
  mint: "hover:border-[rgba(153,246,228,0.35)] hover:shadow-[inset_0_0_48px_rgba(153,246,228,0.08),0_8px_32px_rgba(153,246,228,0.06)]",
};

export const PillarCards: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="relative z-10 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
      {PILLARS.map((pillar) => (
        <button
          key={pillar.id}
          type="button"
          onClick={() => navigate(pillar.path)}
          className={
            "group relative flex h-48 md:h-56 flex-col justify-end overflow-hidden text-left " +
            "rounded-sm border border-white/[0.06] bg-white/[0.05] p-5 md:p-6 " +
            "transition-[transform,border-color,box-shadow,color] duration-500 ease-out " +
            "hover:-translate-y-0.5 " +
            HOVER_RING[pillar.hover]
          }
        >
          <p
            className="mb-1.5 text-[10px] tracking-[0.24em] uppercase transition-colors duration-500 group-hover:text-[#c4b5fd]"
            style={{ color: T.muted }}
          >
            {pillar.subtitle}
          </p>
          <h2
            className={`font-light tracking-tight leading-none text-[clamp(1.5rem,3vw,2rem)] transition-all duration-500 ease-out group-hover:translate-x-0.5 ${
              pillar.hover === "mint" ? "group-hover:text-[#99f6e4]" : "group-hover:text-[#c4b5fd]"
            }`}
            style={{ color: T.text }}
          >
            {pillar.title}
          </h2>
        </button>
      ))}
    </section>
  );
};
